import {
  Box,
  Button,
  HStack,
  IconButton,
  Input,
  InputGroup,
  InputRightElement,
} from '@chakra-ui/react';
import React from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import {
  getDocs,
  searchDocs,
} from '../../stores/slices/resources/docs/docsActions';
import Search from '../icons/Search';

const SearchResource = () => {
  const { activeFolder } = useSelector(state => state.folders);
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    reset,
    control,
    watch,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      query: '',
    },
  });
  const query = watch('query');

  const onSearch = async data => {
    const res = await dispatch(
      searchDocs({
        query,
      })
    );
  };

  return (
    <Box w={'full'}>
      <form onSubmit={handleSubmit(onSearch)}>
        <HStack>
          <InputGroup size={'sm'}>
            <Input
              placeholder="Search resources..."
              _placeholder={{ color: 'lightGray.500' }}
              _focus={{ boxShadow: 'none' }}
              borderRadius={'6px'}
              id="query"
              {...register('query')}
            />
            <InputRightElement
              children={
                <IconButton
                  size={'sm'}
                  variant={'outline'}
                  color={'primary'}
                  borderColor={'primary'}
                  icon={<Search color="primary" />}
                  type={'submit'}
                />
              }
            />
          </InputGroup>
          {query !== '' && (
            <Button
              variant={'ghost'}
              size={'sm'}
              onClick={() => {
                reset({ query: '' });
                dispatch(getDocs({ id: activeFolder.id }));
              }}
            >
              Clear
            </Button>
          )}
        </HStack>
      </form>
    </Box>
  );
};

export default SearchResource;
